import { Type } from '@angular/core';

export type CellData =
  | undefined
  | TextData
  | BooleanData
  | IntegerData
  | FloatData
  | DateData
  | TagsData
  | PhoneData
  | TimestampData
  | CurrencyData
  | CustomCell;

export type CustomData =
  | TextData
  | BooleanData
  | IntegerData
  | FloatData
  | DateData
  | TagsData
  | PhoneData
  | TimestampData
  | CurrencyData
  | CustomCell;
export type CustomDataValue = string | boolean | number | Date | string[] | string;

export interface TextData {
  cellType: 'text';
  value?: string;
  link?: string;
  action?: (() => void) | undefined;
}

export interface BooleanData {
  cellType: 'boolean';
  value?: boolean;
}

export interface IntegerData {
  cellType: 'integer';
  value?: number;
}

export interface FloatData {
  cellType: 'float';
  value?: number;
}

export interface DateData {
  cellType: 'date';
  value?: Date;
}

export interface TagsData {
  cellType: 'tags';
  value?: string[];
}

export interface PhoneData {
  cellType: 'phone';
  value?: string;
}

export interface TimestampData {
  cellType: 'timestamp';
  value?: Date;
}

export interface CurrencyData {
  cellType: 'currency';
  value?: number;
  code?: string;
}

export abstract class CustomCellComponent {
  abstract set value(v: any);
}

export interface CustomCell {
  cellType: 'custom';
  value?: any;
  component: Type<CustomCellComponent>;
}

export interface RowData {
  [columnId: string]: CellData;
}

export interface Row {
  id: string;
  data: RowData;
}
